module.exports = __webpack_public_path__ + "static/media/sad.9d02c6c7.svg";